import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase PlatformEndpointService para utilizar los endpoint especificos en ./assets/resources/context.urls.json
 *
 * *PlatformEndpointService class definition, to use specific endpoint in ./assets/resources/context.urls.json *
 *
 * @type {class}
 */
export class PlatformEndpointService {

  /**
   * Varialbe para guardar la ubicación de endpoints especificos (./assets/resources/context.urls.json)
   *
   * *Variable to save location of endpoints (./assets/resources/context.urls.json) *
   *
   * @type {private}
   * @type {string} DEFAULT_URL_PATH
   */
  private DEFAULT_URL_PATH = './assets/resources/context.urls.json';

  /**
   * Varialbe para guardar la url dentro de DEFAULT_URL_PATH
   *
   * *Variable to save url inside DEFAULT_URL_PATH*
   *
   * @type {public}
   * @type {string} DEFAULT_URL_PATH
   */
  URLS: any;
  MICROFRONTENDS: any;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) { }

  /**
   * Función asincróna para cargar los urls de DEFAULT_URL_PATH
   *
   * *Async function to load urls inside DEFAULT_URL_PATH*
   *
   * @type {public}
   * @type {string} DEFAULT_URL_PATH
   */
  async loadURLS(contextURLPath?: string) {
    let url: string;

    if (contextURLPath === undefined) {
      url = this.DEFAULT_URL_PATH;
    } else {
      url = contextURLPath;
    }

    await this._http.get(url).toPromise().then(response => {
      this.URLS = response['URLS'];
    });
  }

  async loadMICRO(contextURLPath?: string) {
    let url: string;

    if (contextURLPath === undefined) {
      url = this.DEFAULT_URL_PATH;
    } else {
      url = contextURLPath;
    }

    await this._http.get(url).toPromise().then(response => {
      this.MICROFRONTENDS = response['MICROFRONTENDS'];
    });
  }
}
